import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function shahkar(token, params) {
    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.VERIFY_OTP, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default shahkar;